import { render } from "./medium.svg?vue&type=template&id=6afc416c"
const script = {}
script.render = render

export default script